<template>
    <!-- 选择code还是blockly 模式-->
    <div class="asc Brower" :style="{background: 'url(' + allImageMap.bg + ') no-repeat',backgroundSize:'cover'}" >
      <div class="btncenter">
        <div class="btn" @click="comeToCode()">Code</div>
        <div class="btn" @click="comeToBlockly()">Blockly</div>
      </div>
    </div>
</template>
<script>
import store from "../store";
import { mapGetters } from "vuex";
import AdventureManager from "../manager/AdventureManager";
export default {
    data() {
        return {
            blocklyOrCode:true
        }
    },
    mounted() {
    },
    methods: {
        comeToBlockly(){
            localStorage.setItem("chooseMode",'blockly')
            store.state.blocklyShow = true;
            this.$router.push({ path:'/'})
        },
        comeToCode(){
            localStorage.setItem("chooseMode",'code')
            store.state.blocklyShow = false;
            this.$router.push({ path:'/'})
        },
    },
    computed: {
        ...mapGetters(["blocklyShow",'allImageMap'])
    },  
}
</script>
<style>
.btncenter{
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translateX(-50%)
}
.btn{
    cursor: pointer;
    text-decoration: none;
    font: 40px 'Droid Sans', sans-serif;
    font-weight: bold;
    text-shadow: rgba(255,255,255,.5) 0 1px 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    padding: .95em 1.5em .94em 1.5em;
    margin: .5em .5em .5em 1em;
    display: inline-block;
    position: relative;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    border-top: 1px solid rgba(255,255,255,0.8);
    border-bottom: 1px solid rgba(0,0,0,0.1);
    -webkit-transition: background .2s ease-in-out;
    -moz-transition: background .2s ease-in-out;
    transition: background .2s ease-in-out;
    color: hsl(0, 0%, 40%) !important;
    background-color: hsl(0, 0%, 75%);
    -webkit-box-shadow: inset rgba(255,254,255,0.6) 0 0.3em .3em, inset rgba(0,0,0,0.15) 0 -0.1em .3em, /* inner shadow */ hsl(0, 0%, 60%) 0 .1em 3px, hsl(0, 0%, 45%) 0 .3em 1px, /* color border */ rgba(0,0,0,0.2) 0 .5em 5px;
    -moz-box-shadow: inset rgba(255,254,255,0.6) 0 0.3em .3em, inset rgba(0,0,0,0.15) 0 -0.1em .3em, /* inner shadow */ hsl(0, 0%, 60%) 0 .1em 3px, hsl(0, 0%, 45%) 0 .3em 1px, /* color border */ rgba(0,0,0,0.2) 0 .5em 5px;
    box-shadow: inset rgba(255,254,255,0.6) 0 0.3em .3em, inset rgba(0,0,0,0.15) 0 -0.1em .3em, /* inner shadow */ hsl(0, 0%, 60%) 0 .1em 3px, hsl(0, 0%, 45%) 0 .3em 1px, /* color border */ rgba(0,0,0,0.2) 0 .5em 5px;
}
.btn:hover {
  background-color: hsl(0, 0%, 83%);
}
.asc{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 88888888;
}
</style>


// WEBPACK FOOTER //
// src/components/chooseMode.vue